/** Logotipo continnua: círculo con punto sobre cuadrado azul redondeado. */
export function Marca({ conEtiqueta = true }: { conEtiqueta?: boolean }): JSX.Element {
  return (
    <>
      <div className="marca-icono" aria-hidden="true">
        <span />
      </div>
      <span className="marca-nombre">continnua</span>
      {conEtiqueta ? <span className="marca-etiqueta">CMMS</span> : null}
    </>
  );
}
